module.exports = __webpack_public_path__ + "img/bg-index.d82b5fd6.png";